import { computed } from "vue";
import { useAgentApi } from "@/composables/model/agent/useAgentApi.js";
import { useAgentStore } from "@/stores/agent.js";

let pendingLoad = null;

export function useAgent() {
  const store = useAgentStore();
  const { getAdminProfiles } = useAgentApi();

  const agents = computed(() => store.agents);

  async function loadAgents() {
    if (store.loaded) {
      return { success: true, data: store.agents, message: "" };
    }
    if (!pendingLoad) {
      pendingLoad = getAdminProfiles()
        .then((result) => {
          if (result.success) {
            store.setAgents(Array.isArray(result.data) ? result.data : []);
          }
          return result;
        })
        .finally(() => {
          pendingLoad = null;
        });
    }
    return pendingLoad;
  }

  function agentLabel(id) {
    if (id === null || id === undefined || id === "") return "";
    return store.labelById(id);
  }

  return {
    agents,
    loadAgents,
    agentLabel,
  };
}
